/**
 * @packageDocumentation
 * @module annotationToolEnums
 *
 * @remarks
 * Annotation Tool-specific sidebar app IDs and feature IDs.
 */

/**
 * Annotation Tool Sidebar App IDs
 */
export enum AnnotationToolSidebarAppID {
  annotationTool = 'annotation-tool',
}

/**
 * Annotation Tool Feature IDs
 */
export enum AnnotationToolFeatureId {
  annotationDashboard = 'annotation-dashboard',
  annotationSupervisor = 'annotation-supervisor',
  annotation = 'annotator-queue',
  annotatorProjects = 'annotator-projects',
  supervisorProjects = 'supervisor-projects',
  adminProjects = 'admin-projects',
  metrics = 'metrics',
  metricsDashboard = 'dashboard',
  metricsSummary = 'summary',
  metricsEncounterStats = 'encounterStats',
  metricsIRRScore = 'irrScore',
  metricsHolidays = 'holidays',
}
